export default __webpack_public_path__ + "static/media/index.d.03c58376.ts";